export const PWA_SERVICE_WORKER_CLEANUP_KEY = "uraharu:pwa-service-worker-cleanup:v1";

const PWA_SERVICE_WORKER_PATH = "/service-worker.js";
const TARGET_CACHE_NAMES = ["start-url"];

const getRegistrationWorker = (registration: ServiceWorkerRegistration) => {
  return registration.active || registration.waiting || registration.installing;
};

export const isPwaServiceWorkerRegistration = (
  registration: ServiceWorkerRegistration
) => {
  const worker = getRegistrationWorker(registration);
  if (!worker) return false;

  const scopeUrl = new URL(registration.scope);
  const scriptUrl = new URL(worker.scriptURL);

  return (
    scopeUrl.origin === window.location.origin &&
    scopeUrl.pathname === "/" &&
    scriptUrl.origin === window.location.origin &&
    scriptUrl.pathname === PWA_SERVICE_WORKER_PATH
  );
};

const clearPwaCaches = async () => {
  if (!("caches" in window)) return;

  const cacheNames = await caches.keys();
  await Promise.all(
    cacheNames
      .filter((cacheName) => TARGET_CACHE_NAMES.includes(cacheName))
      .map((cacheName) => caches.delete(cacheName))
  );
};

export const cleanupPwaServiceWorker = async () => {
  if (localStorage.getItem(PWA_SERVICE_WORKER_CLEANUP_KEY) === "true") return;

  try {
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(
        registrations
          .filter(isPwaServiceWorkerRegistration)
          .map((registration) => registration.unregister())
      );
    }

    await clearPwaCaches();
  } finally {
    localStorage.setItem(PWA_SERVICE_WORKER_CLEANUP_KEY, "true");
  }
};
